export default "__VITE_ASSET__cA35c2Ub__"